import {
  Content,
  FlexDiv,
  Heading,
  NavBar,
  PileDiv,
  VerticalSpace
} from '@elhub/ds-components'
import styled from 'styled-components'

import TopContainer from 'components/TopContainer/TopContainer'

import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Feedback from '../components/Feedback'
import { LabelMessages } from '../locales/messages/label'
import { EnergyData as EnergyDataApi } from './apis'
import DataExport from './apis/DataExport'
import EnergyDataFile from './apis/EnergyDataFile'
import EnergyDataJob from './apis/EnergyDataJob'
import SecurePing from './apis/SecurePing'

const ApiContent = styled(Content)`
  @media (min-width: 1200px) {
    width: 1200px;
  }
`

const DataExportAPIs = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const index = window.location.href.indexOf('#')
  const location = index === -1 ? '' : window.location.href.substring(index)

  const getDescription = (): ReactNode => {
    switch (location) {
      case '#/secure-ping':
        return <SecurePing />
      case '#/energy-data':
        return <EnergyDataJob />
      case '#/energy-data-file-id':
        return <EnergyDataFile />
      case '#/data-export':
        return <DataExport />
      default:
        return <DataExport />
    }
  }

  const handleNavigation = (link: string) => {
    navigate(link)
  }

  const navbarActive = ['secure-ping', 'energy-data', 'energy-data-file-id'].indexOf(window.location.href.split('#/')[1])

  return (
    <TopContainer>
      <ApiContent>
        <VerticalSpace size='2' />
        <Heading size='large' spacing>
          {t(LabelMessages.DATA_EXPORT_API as any)}
        </Heading>
        <VerticalSpace size='2' />
        <FlexDiv>
          <FlexDiv style={{ marginRight: '3rem' }}>
            <NavBar orientation='vertical' underscore size='small' defaultValue={navbarActive + 1}>
              <NavBar.Link
                onClick={() => {
                  handleNavigation('/data-export-api')
                }}
              >
                Overview
              </NavBar.Link>
              <NavBar.Link
                onClick={() => {
                  handleNavigation('#/secure-ping')
                }}
              >
                Secure ping
              </NavBar.Link>
              <NavBar.Link
                onClick={() => {
                  handleNavigation('#/energy-data')
                }}
              >
                Energy data
              </NavBar.Link>
              <NavBar.Link
                onClick={() => {
                  handleNavigation('#/energy-data-file-id')
                }}
              >
                {'Energy data file/{id}'}
              </NavBar.Link>
            </NavBar>
          </FlexDiv>
          <PileDiv style={{ flex: 2 }}>
            <EnergyDataApi>{getDescription()}</EnergyDataApi>
            <VerticalSpace size='2' />
            <Feedback location='Data Export API Overview page' />
          </PileDiv>
        </FlexDiv>
      </ApiContent>
    </TopContainer>
  )
}
export default DataExportAPIs
